// extracted by mini-css-extract-plugin
export default {"wrapper":"sections-info_wrapper__6btUZ","title":"sections-info_title__xTDqh","sections":"sections-info_sections__UaKtx"};